import { useState, useEffect } from 'react';
import { useAuth } from "../../contexts/AuthContext";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate, useParams } from "react-router";
import ScanList from '../../components/dashboards/lists/ScanList';
import dayjs from 'dayjs';
import * as theme from '../../theme';
import Heading from '../../components/Heading';
import TruCard from '../../components/TruCard';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function Client() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [client, setClient] = useState({});
  const [address, setAddress] = useState('');
  const [dob, setDob] = useState('');
  const { id } = useParams();

  useEffect(() => {
    if (id != null) {
      getClient();
    }
  }, [id]);

  useEffect(() => {
    if (client.dob != null) {
      setDob(dayjs(client.dob).format('MM-DD-YYYY'));
    }
    if (client != {}) {
      if (client.street != null && client.city != null && client.state != null && client.zip != null) {
        // Build address string, including address2 if present
        const addressParts = [client.street];
        if (client.address2) {
          addressParts.push(client.address2);
        }
        addressParts.push(client.city);
        addressParts.push(`${client.state} ${client.zip}`);
        setAddress(addressParts.join(', '));
      } else {
        setAddress('Incomplete address provided');
      }
    }
  }, [client]);

  async function getClient() {
    try {
      const clientRef = doc(db, "clients", id);
      const docSnap = await getDoc(clientRef);
      setClient(docSnap.data() || {});
    } catch (err) {
      console.log("Failed to get client: " + err.message);
    }
  }

  const handleCopyAddress = () => {
    if (address) {
      navigator.clipboard.writeText(address);
      // Optionally add a toast notification here for feedback, e.g., using a library like react-toastify
    }
  };

  const handleCopyEmail = () => {
    if (client.email) {
      navigator.clipboard.writeText(client.email);
    }
  };

  if (!client) {
    return (
      <div style={theme.Container.basic}>
        <div style={theme.Heading}>Client</div>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div style={theme.Container.flexColumnContainer}>
      <div style={theme.Container.flexColumn}>
        <Heading
          title={`${client.firstName || ''} ${client.lastName || ''}`}
          onClick={() => currentUser.role != 'practitioner' ? navigate(`/practitioners/${client.practitionerId}`) : navigate(`/dashboard`)} 
          immediateFamily={client.immediateFamily}
        />
      </div>
      <div style={theme.Container.fullMax}>
          <div style={theme.Container.flexTwo}>
            <Heading
              title={`Chart`}
              subHeading={true}
              icon={'edit'}
              iconAction={() => navigate(`/clients/${id}/edit`)}
            />
            <div style={{ ...theme.Container.flexRow, width: '100%', gap: 20 }}>
              <div style={{ ...theme.Container.flexColumn, flex: 2, gap: 20 }}>
                <div style={theme.Container.flexOne}>
                  <TruCard title={'Date of Birth'} style={{ width: '100%' }}>
                    <div style={theme.TruCard.SubText}>{dob || ''}</div>
                  </TruCard>
                </div>
                <div style={theme.Container.flexOne}>
                  <TruCard title={'Email'} style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                      <div style={theme.TruCard.SubTextLeft}>{client.email || ''}</div>
                      {(currentUser.role === 'admin' || currentUser.role === 'manager') && (
                        <IconButton onClick={handleCopyEmail} color="secondary" size="small">
                          <ContentCopyIcon fontSize="20" />
                        </IconButton>
                      )}
                    </div>
                  </TruCard>
                </div>
                <div style={theme.Container.flexTwo}>
                  <TruCard title={'Mailing Address'} style={{ width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                      <div style={theme.TruCard.SubTextLeft}>{address || ''}</div>
                      {(currentUser.role === 'admin' || currentUser.role === 'manager') && (
                        <IconButton onClick={handleCopyAddress} color="secondary" size="small">
                          <ContentCopyIcon fontSize="20" />
                        </IconButton>
                      )}
                    </div>
                  </TruCard>
                </div>
              </div>
              <div style={{ ...theme.Container.Column, flex: 3, gap: 20 }}>
                <TruCard title={'Specific Concerns/Diagnosis'} style={{ width: '100%' }}>
                  <div style={theme.TruCard.SubTextLeft}>{client.concerns || ''}</div>
                </TruCard>
              </div>
            </div>
          </div>
          <div style={theme.Container.flexOne}>
            <Heading
              title={'Scans'}
              subHeading={true}
              icon={'add'}
              iconAction={() => navigate(`/clients/${id}/scans/add`)}
            />
            <TruCard title={'Scans'}>
              {client.scans ? (
                <ScanList scans={client.scans} clientId={id} />
              ) : (
                <div style={theme.TruCard.SubText}>No Scans Yet</div>
              )}
            </TruCard>
          </div>
      </div>
    </div>
  );
}